// Componente para proteger rotas que requerem autenticação
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useCurrentUser } from '../contexts/UserContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isTokenValid } = useAuth();
  const { currentUser, loading: userLoading, refreshCurrentUser } = useCurrentUser();

  // Verificar token e usuário atual ao montar o componente
  useEffect(() => {
    if (isTokenValid() && !currentUser && !userLoading) {
      // Token válido mas usuário não carregado, tentar buscar
      refreshCurrentUser();
    }
  }, [isTokenValid, currentUser, userLoading, refreshCurrentUser]);

  // Verifica se o token de autenticação é válido
  if (!isTokenValid()) {
    return <Navigate to="/login" replace />;
  }

  // Se token é válido mas ainda está carregando usuário, mostrar loading ou nada
  if (userLoading) {
    return null; // Ou um componente de loading se preferir
  }

  // Se token válido e usuário carregado, renderiza o componente filho
  return <>{children}</>;
};

export default PrivateRoute;